import {useMemo} from 'react';

import isEmpty from 'lodash.isempty';
import isEqual from 'lodash.isequal';
import {HighlightFields} from 'src/modules/event-review/typedefs';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';
import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';

export const useHighlightsHeaderInfo = (
    changeRequest: ChangeRequest,
    event: EventDetailInfo | null,
): Record<HighlightFields, boolean> | null => {
    return useMemo(() => {
        if (!changeRequest || isEmpty(event)) {
            return null;
        }

        const currentEvent = changeRequest.event;

        return {
            [HighlightFields.description]: currentEvent.description !== event.description,
            [HighlightFields.families]: !isEqual(currentEvent.families, event.families),
            [HighlightFields.reported]: currentEvent.reported !== event.reported,
            [HighlightFields.decorated]: currentEvent.decorated !== event.decorated,
            [HighlightFields.deprecated]: currentEvent.deprecated !== event.deprecated,
            [HighlightFields.trigger]: currentEvent.trigger !== (event?.trigger || ''),
        };
    }, [changeRequest, event]);
};
